<div class="relative pr-[30px]">
  <ng-content></ng-content>
  <i
    *ngIf="checked"
    class="absolute right-[8px] top-[50%] transform translate-y-[-50%] text-primary"
    nz-icon
    nzType="check"
    nzTheme="outline"
  ></i>
</div>
